import React from 'react';
import styled from '@emotion/styled';
import { keyframes } from '@emotion/react';
import { Theme } from '@seedlang/constants';
import { gaps } from 'components/layout/stack';
import { Link } from 'react-router';

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const spinIn = keyframes`
  from {
    transform: translateX(-50%) scale(0) rotate(0deg);
    opacity: 0;
  }
  70% {
    transform: translateX(-50%) scale(1.2) rotate(380deg);
    opacity: 1;
  }
  to {
    transform: translateX(-50%) scale(1) rotate(360deg);
    opacity: 1;
  }
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${gaps.lg};
  width: 100%;
  height: 100%;
  min-height: 400px;
  text-align: center;
  padding: 20px;
`;

const IconContainer = styled.div`
  position: relative;
  color: ${Theme.green};
  animation: ${fadeIn} 0.3s ease-out;
`;

const EnvelopeIcon = styled.i`
  font-size: 140px;
`;

const CheckmarkIcon = styled.i`
  color: inherit;
  font-size: 40px;
  position: absolute;
  top: 25%;
  left: 50%;
  transform: translateX(-50%);
  animation: ${spinIn} 0.8s cubic-bezier(0.68, -0.55, 0.265, 1.55) 0.3s both;
`;

const MessageText = styled.p`
  color: #333;
  text-wrap: balance;
  animation: ${fadeIn} 0.3s ease-out 0.1s both;
`;

const EmailChangedMessage = ({ email }) => {
  return (
    <Container>
      <IconContainer>
        <EnvelopeIcon className='fa fa-envelope-o' />
        <CheckmarkIcon className='fa fa-check-circle' />
      </IconContainer>
      <MessageText>
        Your email has been updated, and you have been signed out.<br/>
        We have sent a confirmation email to <strong>{email}</strong>.<br/>
        Once your new email is confirmed, you can <Link className='underline' to='onboarding.sign_in'>sign back in</Link>.
      </MessageText>
    </Container>
  );
};

export default EmailChangedMessage;